function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .icon_menu_ajuda_a{fill:#fff;stroke:#707070;}\n      .icon_menu_ajuda_b{clip-path:url(#icon_menu_ajuda_a);}\n      .icon_menu_ajuda_c{fill:#eceff1;}\n      .icon_menu_ajuda_d{fill:#f44336;}\n      .icon_menu_ajuda_e{fill:#cdd0d2;}\n      .icon_menu_ajuda_f{fill:#d43a2f;}\n    "), React.createElement("clipPath", {
  id: "icon_menu_ajuda_a"
}, React.createElement("rect", {
  className: "icon_menu_ajuda_a",
  width: 19,
  height: 19,
  transform: "translate(1800 1165)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon_menu_ajuda_b",
  transform: "translate(-1800 -1165)"
}, React.createElement("g", {
  transform: "translate(1800 1165)"
}, React.createElement("path", {
  className: "icon_menu_ajuda_c",
  d: "M6.413,7.022l-5.755-1a9.5,9.5,0,0,0,0,6.943l5.755-.99a3.961,3.961,0,0,1,0-4.956Z"
}), React.createElement("path", {
  className: "icon_menu_ajuda_c",
  d: "M18.343,6.025l-5.755,1a3.961,3.961,0,0,1,0,4.956l5.755.99a9.5,9.5,0,0,0,0-6.943Z"
}), React.createElement("path", {
  className: "icon_menu_ajuda_c",
  d: "M9.5,0A9.39,9.39,0,0,0,6.025.657l1,5.755a3.961,3.961,0,0,1,4.956,0l.99-5.755A9.349,9.349,0,0,0,9.5,0Z"
}), React.createElement("path", {
  className: "icon_menu_ajuda_c",
  d: "M11.978,12.587a3.961,3.961,0,0,1-4.956,0l-1,5.755a9.52,9.52,0,0,0,6.951,0Z"
}), React.createElement("path", {
  className: "icon_menu_ajuda_d",
  d: "M6.025.657A9.566,9.566,0,0,0,.657,6.025l5.755,1a4.436,4.436,0,0,1,.61-.61Z"
}), React.createElement("path", {
  className: "icon_menu_ajuda_d",
  d: "M18.343,6.025A9.508,9.508,0,0,0,12.968.657l-.99,5.755a4.486,4.486,0,0,1,.61.61Z"
}), React.createElement("path", {
  className: "icon_menu_ajuda_d",
  d: "M11.978,12.587l1,5.755a9.508,9.508,0,0,0,5.368-5.375l-5.755-.99a4.436,4.436,0,0,1-.61.61Z"
}), React.createElement("path", {
  className: "icon_menu_ajuda_d",
  d: "M6.413,11.978l-5.755.99a9.51,9.51,0,0,0,5.368,5.375l1-5.755a4.436,4.436,0,0,1-.61-.61Z"
}), React.createElement("path", {
  className: "icon_menu_ajuda_e",
  d: "M.657,6.025a9.5,9.5,0,0,0,0,6.943l5.755-.99a3.961,3.961,0,0,1,0-4.956Z"
}), React.createElement("path", {
  className: "icon_menu_ajuda_e",
  d: "M9.5,0A9.39,9.39,0,0,0,6.025.657l1,5.755A3.948,3.948,0,0,1,9.5,5.542Z"
}), React.createElement("path", {
  className: "icon_menu_ajuda_e",
  d: "M7.022,12.587l-1,5.755A9.39,9.39,0,0,0,9.5,19V13.458A3.948,3.948,0,0,1,7.022,12.587Z"
}), React.createElement("path", {
  className: "icon_menu_ajuda_f",
  d: "M6.025.657A9.566,9.566,0,0,0,.657,6.025l5.755,1a4.436,4.436,0,0,1,.61-.61Z"
}), React.createElement("path", {
  className: "icon_menu_ajuda_f",
  d: "M6.413,11.978l-5.755.99a9.51,9.51,0,0,0,5.368,5.375l1-5.755a4.436,4.436,0,0,1-.61-.61Z"
})));

var SvgAjuda = function SvgAjuda(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAjuda, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ajuda.7b0e6f83.svg";
export { ForwardRef as ReactComponent };